import { createSelector } from 'reselect';

import { RootState } from 'store/types';

export const allergiesSelector = (state: RootState) => state.allergies.allergies;

export const allergiesLoadingSelector = createSelector(
  allergiesSelector,
  allergies => allergies.loading
);

export const allergiesDataSelector = createSelector(allergiesSelector, allergies => allergies.data);

export const allergiesErrorSelector = createSelector(
  allergiesSelector,
  allergies => allergies.error
);

export const allergiesRequestStateSelector = createSelector(
  allergiesSelector,
  allergies => allergies.requestState
);

/**
 * Share Allergies
 */
export const shareAllergiesSelector = (state: RootState) => state.allergies.shareAllergies;

export const shareAllergiesSendingSelector = createSelector(
  shareAllergiesSelector,
  shareAllergies => shareAllergies.isSendingAllergies
);

export const shareAllergiesDataSelector = createSelector(
  shareAllergiesSelector,
  shareAllergies => shareAllergies.sharedAllergiesData
);

/**
 * Download Allergies
 */
export const allergiesDownloadsSelector = (state: RootState) => state.allergies.downloadAllergies;

export const allergiesDownloadingSelector = createSelector(
  allergiesDownloadsSelector,
  downloadAllergies => downloadAllergies.isDownloading
);
